<template>
  <div class="time-drum-field">
    <span
      v-if="label"
      class="time-drum-field__label"
    >{{ label }}</span>
    <button
      type="button"
      class="time-drum-field__input"
      :class="{ 'time-drum-field__input--empty': !value, 'time-drum-field__input--disabled': disabled }"
      :disabled="disabled"
      @click="open"
    >
      {{ value || placeholder }}
    </button>

    <v-dialog
      v-model="isOpen"
      max-width="300"
    >
      <v-card>
        <v-card-title class="text-subtitle-2">
          {{ label || '時刻を選択' }}
        </v-card-title>
        <v-card-text class="pb-0">
          <time-option-drum-picker
            v-model="draft"
            :options="dialogOptions"
          />
          <p class="time-drum-field__hint">
            5分単位・スクロールで選択
          </p>
        </v-card-text>
        <v-card-actions class="px-4 pb-3">
          <v-spacer />
          <v-btn
            text
            small
            @click="isOpen = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            small
            @click="confirm"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import TimeOptionDrumPicker from './TimeOptionDrumPicker.vue'

// 「入力欄タップ → ドラムピッカーのダイアログ」型の時刻フィールド。
// 密なフォーム（編集ダイアログ・週まとめ登録の行など）で使う
export default {
  name: 'TimeDrumField',
  components: { TimeOptionDrumPicker },
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '--:--',
    },
    // クリア（未定に戻す）選択肢のラベル。空文字なら出さない
    clearText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 空値で開いたときの初期位置
    defaultValue: {
      type: String,
      default: '20:00',
    },
  },
  setup(props, { emit }) {
    const isOpen = ref(false)
    const draft = ref('')

    const dialogOptions = computed(() => (
      props.clearText ? [{ text: props.clearText, value: '' }, ...props.options] : props.options
    ))

    const open = () => {
      draft.value = props.value || (props.clearText ? '' : props.defaultValue)
      if (!draft.value && !props.clearText) draft.value = props.defaultValue
      if (!props.value && props.clearText) draft.value = ''
      isOpen.value = true
    }

    const confirm = () => {
      emit('input', draft.value)
      isOpen.value = false
    }

    return {
      isOpen,
      draft,
      dialogOptions,
      open,
      confirm,
    }
  },
}
</script>

<style scoped>
.time-drum-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.time-drum-field__label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

.time-drum-field__input {
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 6px;
  background: transparent;
  color: inherit;
  padding: 7px 10px;
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  text-align: left;
  cursor: pointer;
  min-width: 76px;
}

.time-drum-field__input--empty {
  color: #94a3b8;
  font-weight: 500;
}

.time-drum-field__input--disabled {
  opacity: 0.5;
  cursor: default;
}

.time-drum-field__hint {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
  margin: 6px 0 0;
}
</style>
